import React from 'react';
import { Route, Routes } from 'react-router';
import { Box } from '@mui/material';
import { BasePage } from './base';
import { LandingPage } from './landing';
import { ROUTES } from './routes';
import { WorldpayMessanger } from './worldpay';

export const Root = () => (
    <Box height="100%" width="100%" className="hidden-scroll">
        <Routes>
            <Route element={<LandingPage />} path="/" />
            <Route element={<BasePage />} path={ROUTES.BASE + '/*'} />
            <Route element={<WorldpayMessanger />} path={ROUTES.WORLDPAY} />
        </Routes>
    </Box>
);
